module.exports = __webpack_public_path__ + "img/depmap_svg_V85.7fa37e21.svg";